import * as pdfjsLib from 'pdfjs-dist';
import mammoth from 'mammoth';

// Set up PDF.js worker - use public directory worker for Amplify compatibility
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

export const textExtractionService = {
  // Extract text from PDF files
  extractFromPDF: async (file: File): Promise<string> => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let fullText = '';

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      const pageText = textContent.items
        .map((item: any) => item.str)
        .join(' ');
      fullText += pageText + '\n';
    }

    return fullText.trim();
  },

  // Extract text from Word documents (.docx and .doc)
  extractFromWord: async (file: File): Promise<string> => {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer });
    return result.value.trim();
  },

  // Main extraction function that handles different file types
  extractText: async (file: File): Promise<{ text: string; newFileName: string }> => {
    const fileType = file.type;
    const originalName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
    const newFileName = `${originalName}.txt`;

    let extractedText: string;

    if (fileType === 'application/pdf') {
      extractedText = await textExtractionService.extractFromPDF(file);
    } else if (
      fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      fileType === 'application/msword'
    ) {
      extractedText = await textExtractionService.extractFromWord(file);
    } else {
      throw new Error('Unsupported file type for text extraction');
    }

    return { text: extractedText, newFileName };
  },

  // Create a new File object with extracted text
  createTextFile: (text: string, fileName: string): File => {
    const blob = new Blob([text], { type: 'text/plain' });
    return new File([blob], fileName, { type: 'text/plain' });
  }
};